import axios from "axios";
import logger from "./logger";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  // We rely on bearer-token auth (Authorization header) because the
  // preview routes frontend and backend on different subdomains, so
  // credentialed wildcard CORS is rejected by the browser.
  withCredentials: false,
});

// Add bearer token from localStorage as fallback (cross-origin cookie may be blocked in some browsers)
api.interceptors.request.use((config) => {
  try {
    const token = localStorage.getItem("mordomo_token");
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
  } catch (err) {
    // localStorage may be blocked in privacy mode / embedded webviews — silent in production.
    logger.debug("[api] token read failed:", err?.message);
  }
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Algo correu mal. Tente de novo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  // FastAPI Pydantic validation error: {msg, type, loc}
  if (detail && typeof detail.msg === "string") return detail.msg;
  // Mordomo-shaped gating/feature error: {code, message, ...}
  if (detail && typeof detail.message === "string") return detail.message;
  // Last-resort: never let "[object Object]" leak to the UI.
  try {
    const json = JSON.stringify(detail);
    if (json && json !== "{}") return json;
  } catch {
    /* circular — fall through */
  }
  return "Algo correu mal. Tente de novo.";
}

export default api;
